import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "order-template-create" }
const _hoisted_2 = { class: "order-template-create__header" }
const _hoisted_3 = { class: "order-template-create__content" }
const _hoisted_4 = {
  key: 1,
  class: "order-template-create__loading"
}
const _hoisted_5 = {
  key: 2,
  class: "order-template-create__warning"
}
const _hoisted_6 = { class: "order-template-create__card-header" }
const _hoisted_7 = { class: "order-template-create__heading" }
const _hoisted_8 = { class: "order-template-create__subtitle" }
const _hoisted_9 = { class: "order-template-create__section" }
const _hoisted_10 = { class: "order-template-create__meta" }
const _hoisted_11 = { class: "order-template-create__field-row" }
const _hoisted_12 = { class: "order-template-create__field-label" }
const _hoisted_13 = { class: "order-template-create__field-control" }
const _hoisted_14 = { class: "order-template-create__field-row order-template-create__field-row--number" }
const _hoisted_15 = { class: "order-template-create__field-label" }
const _hoisted_16 = { class: "order-template-create__field-control" }
const _hoisted_17 = { class: "order-template-create__number" }
const _hoisted_18 = ["value", "disabled"]
const _hoisted_19 = { class: "order-template-create__number-unit" }
const _hoisted_20 = {
  key: 0,
  class: "order-template-create__field-error"
}
const _hoisted_21 = { class: "order-template-create__note" }
const _hoisted_22 = { class: "order-template-create__mapping" }
const _hoisted_23 = { class: "order-template-create__mapping-header" }
const _hoisted_24 = { class: "order-template-create__mapping-body" }
const _hoisted_25 = { class: "order-template-create__mapping-checkbox" }
const _hoisted_26 = ["id", "checked", "disabled", "onChange"]
const _hoisted_27 = ["for"]
const _hoisted_28 = { class: "order-template-create__mapping-cell" }
const _hoisted_29 = ["value", "placeholder", "disabled", "onInput"]
const _hoisted_30 = {
  key: 0,
  class: "order-template-create__field-error"
}
const _hoisted_31 = { class: "order-template-create__actions" }
const _hoisted_32 = {
  key: 0,
  class: "order-template-create__form-error"
}
const _hoisted_33 = { class: "order-template-create__action-buttons" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = ["disabled"]

import { useRoute, useRouter } from 'vue-router';
import SettingsPageTitle from '@/settingsModule/components/SettingsPageTitle.vue';
import Mdi from '@/corePagesModule/components/Mdi.vue';
import { useOrderTemplateForm } from '@/orderTemplateModule/composables/useOrderTemplateForm';
import { i18n } from '@/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderTemplateCreatePage',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const t = i18n.t;

const {
  fileOriginalName,
  formMessage,
  formMessageType,
  initializing,
  hasUploadInfo,
  isBusy,
  fieldState,
  mappingStates,
  maxOrdersFieldName,
  buildMappingFieldName,
  handleMaxOrdersPerSheetInput,
  handleToggleField,
  handleStartCellInput,
  submit,
  cancel,
} = useOrderTemplateForm({ route, router });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createVNode(SettingsPageTitle, {
        label: _unref(t)('設定 > 書式・帳票 > 書式設定')
      }, null, 8, ["label"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_unref(formMessage) && _unref(formMessageType) !== 'error')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['order-template-create__message', { 'order-template-create__message--error': _unref(formMessageType) === 'error' }])
          }, _toDisplayString(_unref(formMessage)), 3))
        : _createCommentVNode("", true),
      (_unref(initializing))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(t)('テンプレート情報を読み込んでいます…')), 1))
        : (!_unref(hasUploadInfo))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(t)('先に書式ファイルをアップロードしてからこのページを開いてください。')), 1))
          : (_openBlock(), _createElementBlock("form", {
              key: 3,
              class: "order-template-create__card",
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_unref(submit) && _unref(submit)(...args)), ["prevent"]))
            }, [
              _createElementVNode("header", _hoisted_6, [
                _createElementVNode("h1", _hoisted_7, _toDisplayString(_unref(t)('項目とセルのマッピング')), 1),
                _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(t)('各データ項目をExcelのどのセルから出力するか指定してください。複数出力する項目は「複数出力」にチェックを入れてください。')), 1)
              ]),
              _createElementVNode("section", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('ファイル名')), 1),
                    _createElementVNode("div", _hoisted_13, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(fileOriginalName) ? (fileOriginalName).value = $event : null)),
                        class: "order-template-create__input",
                        readonly: ""
                      }, null, 512), [
                        [_vModelText, _unref(fileOriginalName)]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)('1シートあたりの出力上限数')), 1),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("input", {
                          value: _unref(fieldState)[_unref(maxOrdersFieldName)].value.value,
                          class: "order-template-create__input order-template-create__input--number",
                          type: "number",
                          min: "1",
                          max: "10000",
                          disabled: _unref(isBusy),
                          onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref(handleMaxOrdersPerSheetInput)(($event.target as HTMLInputElement).value)))
                        }, null, 40, _hoisted_18),
                        _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(t)('個')), 1)
                      ]),
                      (_unref(fieldState)[_unref(maxOrdersFieldName)].isError.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                            _createVNode(Mdi, {
                              class: "order-template-create__field-error-icon",
                              icon: "error_outline"
                            }),
                            _createElementVNode("span", null, _toDisplayString(_unref(fieldState)[_unref(maxOrdersFieldName)].errorMessage.value), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(t)(
                '設定例: 商品名をA1に設定し、1シートあたりの出力上限数を20個とした場合、A1からA20まで出力されます。21個目以降は2つ目のファイルとして出力されます。'
              )), 1)
              ]),
              _createElementVNode("section", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('出力項目')), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('項目名')), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('出力開始セル')), 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mappingStates), (field, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: field.fieldKey,
                      class: "order-template-create__mapping-row"
                    }, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("input", {
                          id: `mapping-field-${field.fieldKey}`,
                          type: "checkbox",
                          class: "order-template-create__checkbox",
                          checked: field.enabled,
                          disabled: _unref(isBusy),
                          onChange: ($event: any) => (_unref(handleToggleField)(index, ($event.target as HTMLInputElement).checked))
                        }, null, 40, _hoisted_26)
                      ]),
                      _createElementVNode("label", {
                        class: "order-template-create__mapping-label",
                        for: `mapping-field-${field.fieldKey}`
                      }, _toDisplayString(_unref(t)(field.label)), 9, _hoisted_27),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("input", {
                          value: field.startCell,
                          class: "order-template-create__input",
                          type: "text",
                          placeholder: _unref(t)('例: A1'),
                          maxlength: "6",
                          disabled: !field.enabled || _unref(isBusy),
                          onInput: ($event: any) => (_unref(handleStartCellInput)(index, ($event.target as HTMLInputElement).value))
                        }, null, 40, _hoisted_29),
                        (_unref(fieldState)[_unref(buildMappingFieldName)(field.fieldKey)].isError.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_30, [
                              _createVNode(Mdi, {
                                class: "order-template-create__field-error-icon",
                                icon: "error_outline"
                              }),
                              _createElementVNode("span", null, _toDisplayString(_unref(fieldState)[_unref(buildMappingFieldName)(field.fieldKey)].errorMessage.value), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                (_unref(formMessage) && _unref(formMessageType) === 'error')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createVNode(Mdi, {
                        class: "order-template-create__form-error-icon",
                        icon: "error_outline"
                      }),
                      _createElementVNode("span", null, _toDisplayString(_unref(formMessage)), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("button", {
                    class: "order-template-create__primary",
                    type: "submit",
                    disabled: _unref(isBusy)
                  }, _toDisplayString(_unref(isBusy) ? _unref(t)('保存中…') : _unref(t)('テンプレートを保存')), 9, _hoisted_34),
                  _createElementVNode("button", {
                    class: "order-template-create__secondary",
                    type: "button",
                    disabled: _unref(isBusy),
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(cancel) && _unref(cancel)(...args)))
                  }, _toDisplayString(_unref(t)('キャンセル')), 9, _hoisted_35)
                ])
              ])
            ], 32))
    ])
  ]))
}
}

})